import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'
import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import useAuth from "../../../useAuth";

import * as verifydocumentapi from '../../../apis/verifydocumentupload'
import { FaCheckCircle, FaTimesCircle, FaPlus } from 'react-icons/fa'; // Import FontAwesome icons
import { MEDIA_SERVER_URL } from '../../../constants/constants';
import TriggerVerificationModal from '../TriggerVerificationModal';
import { adminTriggerVerification } from '../../../apis/verification_request_by_user';

function Document_data() {
    const location = useLocation();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const { user } = useAuth();
    const hasViewDocument = user?.permissions?.Verification?.['View Document']?.selected || user?.role === 'superadmin';
    const [verifydocument, setverifydocument] = useState([])
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [reviewingRequestId, setReviewingRequestId] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('')
    const [inputPageNumber, setInputPageNumber] = useState(''); // State to hold the input page number
    const [inputFocus, setInputFocus] = useState(false);
    const [buttonFocus, setButtonFocus] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState(queryParams.get('status') || '');
    const [typeFilter, setTypeFilter] = useState('identity_only');
    const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);

    useEffect(() => {
        const status = queryParams.get('status');
        if (status) {
            setStatusFilter(status);
        }
    }, [queryParams]);


    const getallverificationdocument = async (page, searchTerm = '', status = '', type = '') => {
        try {
            const response = await verifydocumentapi.getalldocument(page, searchTerm, status, type)
            console.log(response.data, "response from blocked users");
            setverifydocument(response.data)
            setTotalPages(response.pagination.pages);

        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    // useEffect(() => {
    //     getallverificationdocument();
    // }, []);


    useEffect(() => {
        getallverificationdocument(currentPage, searchTerm, statusFilter, typeFilter);
    }, [currentPage, searchTerm, statusFilter, typeFilter]);

    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
        setCurrentPage(1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter, typeFilter]);


    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            // setCurrentPage((prevPage) => prevPage + 1);
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            // setCurrentPage((prevPage) => prevPage - 1);
            setCurrentPage(currentPage - 1);
        }
    };
    const handleGoToPage = () => {
        const pageNumber = parseInt(inputPageNumber, 10);
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setInputPageNumber('')
        } else {
            alert(`Please enter a valid page number between 1 and ${totalPages}`);
        }
    };


    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    }
    const handleOpenModal = (document) => {
        setSelectedDocument(document);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedDocument(null);
        setModalOpen(false);
    };
    const handleNoAccess = () => {
        alert('You are not able to access this feature.');
    };
    const handleReview = async (requestId, status, reason = "") => {
        const confirmed = window.confirm(`Are you sure you want to ${status} this request?`);
        if (!confirmed) return;

        setIsLoading(true);
        try {
            const response = await verifydocumentapi.reviewVerificationRequest(requestId, status, reason);
            if (response.success) {
                alert(`Request ${status} successfully`);
                setIsRejectionModalOpen(false);
                setRejectionReason('');
                getallverificationdocument(currentPage, searchTerm, statusFilter, typeFilter);
            } else {
                alert(response.message || `Failed to ${status} request`);
            }
        } catch (error) {
            console.error(`Error ${status} request:`, error);
            alert(`Error processing ${status}`);
        } finally {
            setIsLoading(false);
        }
    };

    const openRejectionModal = (requestId) => {
        setReviewingRequestId(requestId);
        setIsRejectionModalOpen(true);
    };

    const handleUndoApproval = async (requestId) => {
        const confirmed = window.confirm(`Are you sure you want to undo approval for this request?`);
        if (!confirmed) return;

        setIsLoading(true);
        try {
            const response = await verifydocumentapi.undoApproval(requestId);
            if (response.success) {
                alert(response.message || `Approval undone successfully`);
                getallverificationdocument(currentPage, searchTerm, statusFilter, typeFilter);
            } else {
                alert(response.message || `Failed to undo approval`);
            }
        } catch (error) {
            console.error(`Error undoing approval:`, error);
            alert(`Error undoing approval`);
        } finally {
            setIsLoading(false);
        }
    };

    const handleTriggerRequest = async (data) => {
        try {
            const response = await adminTriggerVerification(data);
            if (response.success) {
                alert(response.message || 'Verification request sent successfully');
                getallverificationdocument(currentPage, searchTerm, statusFilter, typeFilter);
            } else {
                alert(response.message || 'Failed to send verification request');
            }
        } catch (error) {
            console.error('Error triggering verification:', error);
            alert('Error sending verification request');
        }
    };
    
    return (

        <IncludeSideBar>
            <div>
                <p>
                    Here we are displaying the sections of Verification Document.
                </p>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Search by user name"
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    />
                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    >
                        <option value="">All Statuses</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                    </select>

                    <button
                        onClick={() => setIsTriggerModalOpen(true)}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '4px',
                            border: 'none',
                            backgroundColor: '#1a237e',
                            color: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: '600',
                            marginLeft: 'auto'
                        }}
                    >
                        <FaPlus /> Send Verification Request
                    </button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>S/N</th>
                            <th>User ID</th>
                            <th>User Name</th>

                            <th>Nick name</th>
                            <th>Email</th>
                            <th>Apply Date</th>
                            <th>Verifyed User</th>


                            <th>Action</th> {/* New column for the Status button */}
                        </tr>
                    </thead>
                    <tbody>
                        {verifydocument.map((user, index) => {
                            const userIsVerified = user.user.identity_verified === 1;

                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{user.user.id}</td>
                                    <td>
                                        {user.user.username}
                                    </td>

                                    <td>{user.user.nickname}</td>
                                    <td>{user.user.email}</td>
                                    <td>{formatDate(user.createdAt)}</td>
                                    <td>
                                        <div style={ticstyle}>
                                            {userIsVerified ? (
                                                <FaCheckCircle style={{ color: 'green', fontSize: '24px' }} />
                                            ) : (
                                                <FaTimesCircle style={{ color: 'red', fontSize: '24px' }} />
                                            )}
                                        </div>
                                    </td>


                                    <td>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button onClick={() => {
                                                if (hasViewDocument) {
                                                    handleOpenModal(user)
                                                } else {
                                                    handleNoAccess()
                                                }
                                            }}
                                                style={{
                                                    backgroundColor: !hasViewDocument ? '#C5C6C7' : '',
                                                    cursor: !hasViewDocument ? 'not-allowed' : 'pointer',
                                                }}
                                            >View Document</button>

                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                {user.status?.toLowerCase() === 'pending' && (
                                                    <>
                                                        <button
                                                            onClick={() => handleReview(user.id, 'approved')}
                                                            style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                                                        >
                                                            Approve
                                                        </button>
                                                        <button
                                                            onClick={() => openRejectionModal(user.id)}
                                                            style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                                                        >
                                                            Reject
                                                        </button>
                                                    </>
                                                )}
                                                {user.status?.toLowerCase() === 'approved' && (
                                                    <button
                                                        onClick={() => handleUndoApproval(user.id)}
                                                        style={{ backgroundColor: '#ffc107', color: 'black', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                                                    >
                                                        Undo Approval
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}

                    </tbody>
                </table>

                <div className="pagination">
                    <button onClick={handlePrevious}>Previous</button>
                    {Array.from({ length: Math.min(totalPages, 20) }, (_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => handlePageChange(index + 1)}
                            className={currentPage === index + 1 ? "active" : ""}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={handleNext}>Next</button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginLeft: '10px' }}>
                    <input
                        type="number"
                        value={inputPageNumber}
                        onChange={(e) => setInputPageNumber(e.target.value)}
                        placeholder="Page No"
                        style={{
                            padding: '5px',
                            fontSize: '14px',
                            // border: '1px solid #ccc',
                            border: `2px solid ${inputFocus ? 'green' : '#ccc'}`,

                            borderRadius: '4px 0 0 4px',
                            outline: 'none',
                            width: '90px'
                        }}
                        onFocus={() => setInputFocus(true)}
                        onBlur={() => setInputFocus(false)}
                    />
                    <button
                        onClick={handleGoToPage}
                        style={{
                            padding: '6.5px 10px',
                            fontSize: '14px',
                            border: '1px solid #ccc',
                            borderLeft: 'none',
                            borderRadius: '0 4px 4px 0',
                            // backgroundColor: '#007bff',

                            backgroundColor: `${buttonFocus ? 'green' : '#007bff'}`,
                            color: 'white',
                            cursor: 'pointer',
                            outline: 'none',
                        }}


                    >
                        Go
                    </button>
                </div>

            </div>
            <DocumentDetailModal
                isOpen={modalOpen}
                onRequestClose={handleCloseModal}
                document={selectedDocument}
            />
            {isRejectionModalOpen && (
                <RejectionModal
                    onClose={() => setIsRejectionModalOpen(false)}
                    onReject={(reason) => handleReview(reviewingRequestId, 'rejected', reason)}
                />
            )}
            <TriggerVerificationModal
                isOpen={isTriggerModalOpen}
                onClose={() => setIsTriggerModalOpen(false)}
                onTrigger={handleTriggerRequest}
                initialType="identity_only"
            />
        </IncludeSideBar >

    )
}

export default Document_data

const ticstyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

}

const DocumentDetailModal = ({ isOpen, onRequestClose, document }) => {
    if (!document) return null;

    const getDisplayValue = (value) => (value ? value : 'N/A');

    const modalStyles = {
        display: isOpen ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: '1000',
        overflow: 'auto',
    };

    const modalContentStyles = {
        backgroundColor: '#fff',
        borderRadius: '15px',
        width: '600px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'left',
        position: 'relative',
        maxHeight: '80%',
        overflowY: 'auto',
    };

    const headerStyles = {
        backgroundColor: '#f0f0f0',
        padding: '10px',
        borderTopLeftRadius: '15px',
        borderTopRightRadius: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };

    const closeButtonStyles = {
        backgroundColor: '#ff4d4f',
        color: 'white',
        padding: '5px 10px',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const profileSectionStyles = {
        display: 'flex',
        alignItems: 'center',
        padding: '20px',
        borderBottom: '1px solid #ddd',
    };

    const profileImgStyles = {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginRight: '20px',
    };

    const userDetailsStyles = {
        flex: 1,
    };

    const userDetailsLabelStyles = {
        fontWeight: 'bold',
        color: '#555',
        marginBottom: '5px',
    };

    const userDetailsValueStyles = {
        color: '#333',
    };

    const documentSectionStyles = {
        padding: '20px',
    };

    const documentItemStyles = {
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
    };

    const documentImgStyles = {
        width: '100px',
        height: '100px',
        borderRadius: '10px',
        marginRight: '20px',
        objectFit: 'cover',
    };

    const documentInfoStyles = {
        flex: 1,
    };

    const documentLabelStyles = {
        fontWeight: 'bold',
        color: '#555',
        marginBottom: '5px',
    };

    const documentDownloadButtonStyles = {
        backgroundColor: '#007bff',
        color: 'white',
        padding: '8px 15px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const handleDownload = (url, fileName) => {
        const data = `${MEDIA_SERVER_URL}/${url}`
        saveAs(data, fileName)
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <div style={headerStyles}>
                    <h2>Document Details</h2>
                    <button
                        style={{ ...closeButtonStyles, marginRight: '10px' }}
                        onClick={onRequestClose}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#ff1a1a')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#ff4d4f')}
                    >
                        &times;
                    </button>
                </div>
                <div style={profileSectionStyles}>
                    <img src={document.user.profile_pic} alt="Profile" style={profileImgStyles} />
                    <div style={userDetailsStyles}>
                        <div>
                            <span style={userDetailsLabelStyles}>User ID:</span>
                            <span style={userDetailsValueStyles}>{getDisplayValue(document.user_id)}</span>
                        </div>
                        <div>
                            <span style={userDetailsLabelStyles}>Username:</span>
                            <span style={userDetailsValueStyles}>{getDisplayValue(document.user.username)}</span>
                        </div>
                    </div>
                </div>
                <div style={documentSectionStyles}>

                    {document.photo && (
                        <div>
                            <span style={documentLabelStyles}>Clear Photo</span>

                            <div style={documentItemStyles}>

                                <img src={`${MEDIA_SERVER_URL}/${document.photo}`} alt="Verification Profile" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                    <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.photo, 'clear_photo.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {document.passport && (
                        <div>
                            <span style={documentLabelStyles}>Passport</span>

                            <div style={documentItemStyles}>
                                <img src={`${MEDIA_SERVER_URL}/${document.passport}`} alt="Passport" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                    <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.passport, 'passport.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {document.drivingLicenceFront && (
                        <div>
                            <span style={documentLabelStyles}>Driving License Front</span>

                            <div style={documentItemStyles}>
                                <img src={`${MEDIA_SERVER_URL}/${document.drivingLicenceFront}`} alt="Driving License Front" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                    <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.drivingLicenceFront, 'driving_license_front.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {document.drivingLicenceBack && (
                        <div>
                            <span style={documentLabelStyles}>Driving License Back</span>

                            <div style={documentItemStyles}>
                                <img src={`${MEDIA_SERVER_URL}/${document.drivingLicenceBack}`} alt="Driving License Back" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                    <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.drivingLicenceBack, 'driving_license_back.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {document.otherIdProofFront && (
                        <div>
                            <span style={documentLabelStyles}>Driving License Back</span>

                            <div style={documentItemStyles}>
                                <img src={`${MEDIA_SERVER_URL}/${document.otherIdProofFront}`} alt="Other ID Proof Front" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.otherIdProofFront, 'other_id_proof_front.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {document.otherIdProofBack && (
                        <div>
                            <span style={documentLabelStyles}>Other ID Proof Back</span>

                            <div style={documentItemStyles}>
                                <img src={`${MEDIA_SERVER_URL}/${document.otherIdProofBack}`} alt="Other ID Proof Back" style={documentImgStyles} />
                                <div style={documentInfoStyles}>
                                    <button
                                        style={documentDownloadButtonStyles}
                                        onClick={() => handleDownload(document.otherIdProofBack, 'other_id_proof_back.jpg')}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const RejectionModal = ({ onClose, onReject }) => {
    const [reason, setReason] = useState('');

    const modalStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1100,
    };

    const contentStyle = {
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        width: '400px',
        textAlign: 'center',
    };

    const textareaStyle = {
        width: '100%',
        height: '100px',
        margin: '10px 0',
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    };

    const buttonStyle = {
        padding: '8px 16px',
        margin: '0 5px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
    };

    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <h3>Rejection Reason</h3>
                <textarea
                    style={textareaStyle}
                    placeholder="Enter reason for rejection..."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
                <div>
                    <button
                        style={{ ...buttonStyle, backgroundColor: '#dc3545', color: 'white' }}
                        onClick={() => {
                            if (!reason.trim()) {
                                alert('Please provide a reason');
                                return;
                            }
                            onReject(reason);
                        }}
                    >
                        Confirm Reject
                    </button>
                    <button
                        style={{ ...buttonStyle, backgroundColor: '#6c757d', color: 'white' }}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};
